const H = {
  name: "Suitcase",
  dimensions: { width: 40, height: 40 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_27_2160)">
    <path d="M32.5024 19.0029H29.5024H10.5024H7.50244H3.00244C2.45244 19.0029 2.00244 18.5529 2.00244 18.0029V7.00293H13.0024H27.0024H37.0024C37.5524 7.00293 38.0024 7.45293 38.0024 8.00293V19.0029H32.5024ZM30.0024 21.0029H32.0024V25.0029H30.0024V21.0029ZM8.00244 21.0029H10.0024V25.0029H8.00244V21.0029ZM38.0024 38.0029H3.00244C2.45244 38.0029 2.00244 37.5529 2.00244 37.0029V21.0029H6.00244V25.5029C6.00244 26.3329 6.67244 27.0029 7.50244 27.0029H10.5024C11.3324 27.0029 12.0024 26.3329 12.0024 25.5029V21.0029H28.0024V25.5029C28.0024 26.3329 28.6724 27.0029 29.5024 27.0029H32.5024C33.3324 27.0029 34.0024 26.3329 34.0024 25.5029V21.0029H37.0024C37.5524 21.0029 38.0024 21.4529 38.0024 22.0029V38.0029ZM15.0024 2.00293H24.0024C24.5524 2.00293 25.0024 2.45293 25.0024 3.00293V5.00293H16.0024C15.4524 5.00293 15.0024 4.55293 15.0024 4.00293V2.00293ZM38.0024 5.00293H27.0024V2.00293C27.0024 0.90293 26.1024 0.00292969 25.0024 0.00292969H15.0024C13.9024 0.00292969 13.0024 0.90293 13.0024 2.00293V5.00293H2.00244C0.902441 5.00293 0.00244141 5.90293 0.00244141 7.00293V19.0029V21.0029V38.0029C0.00244141 39.1029 0.902441 40.0029 2.00244 40.0029H38.0024C39.1024 40.0029 40.0024 39.1029 40.0024 38.0029V21.0029V19.0029V7.00293C40.0024 5.90293 39.1024 5.00293 38.0024 5.00293Z" />
    </g>
    <defs>
    <clipPath id="clip0_27_2160">
    <rect width="40" height="40" fill="currentColor" transform="translate(0.00244141 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  H as Suitcase
};
